import { FormatDate } from '../../../../utils/formatDate';
import { Box, Typography } from '@mui/material';
import Iconify from '../../../Iconify';
import '../../../../css/machines/MachineTotalExpense.css';

const MachineInvoiceFrequence = ({ machineDetailsData }) => {

    const dates = machineDetailsData?.invoice_machine?.map(item => new Date(item?.invoice.date));
    const start_date = new Date(Math.min(...dates));
    const end_date = new Date(Math.max(...dates));

    return (
        <Box className='machineExpense_main_box'>
            <Typography className='machineExpense_title'>Fréquence des Factures</Typography>
            <Box className='machineExpense_totsl_warning_box'>
                <Box className='machineExpense_totalCount_box' sx={{ gap: '5px' }}>
                    <Typography className='machineExpense_total_count'>{machineDetailsData?.invoice_machine?.length}</Typography>
                    <Typography className='machineExpense_unit_text'>factures</Typography>
                </Box>
                <Typography className='machineExpense_totsl_description_text'>Total des factures sur toutes les années</Typography>
                {dates?.length > 0 &&
                    <Box className='machineExpense_warning_main_box'>
                        <Iconify icon={"lucide:clock-fading"} width='18px' height='18px' />
                        {dates?.length > 1 ?
                            <Typography sx={{ color: '#6E6D6D' }}>{FormatDate(start_date)} - {FormatDate(end_date)}</Typography>
                            :
                            <Typography sx={{ color: '#6E6D6D' }}>{FormatDate(start_date)}</Typography>

                        }
                    </Box>
                }
            </Box>
        </Box>
    )
}

export default MachineInvoiceFrequence